import ControlItem from './ControlItem'

function ExperimentItem({
  experiment,
  //experimentList,
  countButton,
  extraGraphics = false,
}: any) {
  return experiment.map((item: any, index1: number) => (
    <div key={index1} className='row g-5 gx-xl-10'>
      <div
        className='col-xl-12 col-12 sal-animate'
        data-sal-delay='200'
        data-sal='slide-up'
        data-sal-duration='500'
      >
        <div className='card border min-h-125px px-5 h-10'>
          <div className='card-body d-flex flex-column px-5'>
            {/*}
            <div className='card-header pt-0 px-0 d-flex align-items-start border-0'>
       
              <div className='symbol symbol-75px mb-5'>
                <img src={toAbsoluteUrl('/media/logos/data-science.png')} alt='image' />
              </div>
              
            </div>
            */}
            <span className='fs-4 text-gray-800 fw-bold mb-0'> {item.name}</span>
            <div className='fw-semibold text-gray-400'>
              <div className=' d-flex flex-column px-0 pt-2'>
                <span
                  className='fw-semibold text-gray-400 me-15'
                  dangerouslySetInnerHTML={{__html: String(item.description)}}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* */}

      {item.circuitDTO?.map((circuitItem: any, index2: number) => (
        <ControlItem
          key={circuitItem.id}
          circuitData={circuitItem}
          index1={index1}
          index2={index2}
          // experimentList={experimentList}
          countButton={countButton}
          extraGraphics={extraGraphics}
          deviceCode={item.deviceCode}
        />
      ))}
    </div>
  ))
}

export default ExperimentItem
